import React, { useEffect } from 'react';
import Layout from '../layouts/Layout';
import { PUBLIC_URL } from '../utils/const';
import { BlogPage } from 'reactyll';
import MarkDown from 'react-markdown'
import rehypeRaw from 'rehype-raw';
import { Head } from 'vite-react-ssg';
import { useFathom } from '../contexts/FathomContext';
import { Container, Title, Text, Image, Box, Paper, Anchor, Group, Button, Stack } from '@mantine/core';
import { redirectWithParameters } from '../utils/common';
import { getBlogByLanguage } from '../utils/blog';
import { blogs } from '../_blog/routes';
import { useTranslation } from 'react-i18next';

export interface ExtraProperties {
    date: string
    headline: string
    description: string
    publishDate: string
}

const content: BlogPage<ExtraProperties> = JSON.parse(decodeURIComponent(atob(`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`)));


const InnerBlogTemplate: React.FC = () => {
    const { trackEvent } = useFathom();
    const { i18n } = useTranslation();
    
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const langParam = urlParams.get('lang');

        if (langParam) {
            const matchingLanguage = content.languages.find(([lang, url]) => lang === langParam);
            if (matchingLanguage) {
                const [_, url] = matchingLanguage;
                window.location.href = `${url}`;
            }
        }
        const handleButtonClick = (event: any) => {
            if (event.target.classList.contains('cta')) {
                console.log("CTA clicked")
                trackEvent("Blog > CTA Clicked");
                window.location.href = "/login?signup=true"
            }
        };

        const parentElement = document.getElementById('blog-wrapper');
        if (parentElement) {
            document.addEventListener('click', handleButtonClick);
        }

        return () => {
            if (parentElement) {
                parentElement.removeEventListener('click', handleButtonClick);
            }
        };
    }, []);

    return (
        <>
            <Head>
                <meta charSet="utf-8" />
                <title>{content.properties.title}</title>
                <link rel="canonical" href={`https://calensync.live${PUBLIC_URL}${content.properties.language === "en" ? "" : `/${content.properties.language}`}${content.properties.url}`} />
                {content.languages.map(([language, url]) => (
                    <link rel="alternate" key={language} href={`https://calensync.live${PUBLIC_URL}${url}`} hrefLang={language} />
                ))}
                <meta name="description" content={content.properties.description} />
                <meta property="og:title" content={content.properties.title} />
                <meta property="og:url" content={`https://calensync.live${PUBLIC_URL}${content.properties.url}`} />
                <meta property="og:description" content={content.properties.description} />
                <meta property="og:publish_date" content={content.properties.publishDate} />
            </Head>
            <Container size="md" mt="md" id="blog-wrapper">
                <Paper p="md" my="md">
                    <Box mb="md" mt="md">
                        <Title order={1} mb="xs">{content.properties.title}</Title>
                        <Text fs="italic" c="dimmed">{content.properties.date}</Text>
                    </Box>

                    <Box mb="xl">
                        <MarkDown
                            rehypePlugins={[rehypeRaw]}
                            children={content.markdown}
                            components={{
                                h1(props) {
                                    const { children } = props
                                    return <Title order={1}>{children}</Title>
                                },
                                p(props) {
                                    const { children } = props
                                    return <Text size="lg" mb="md">
                                        {children}
                                    </Text>
                                },
                                strong(props) {
                                    const { children } = props
                                    return <Text span fw={700}><b>{children}</b></Text>
                                },
                                h2(props) {
                                    const { children } = props
                                    return <Title fw={400} order={2} mt="xl" pt="md" pb="md">{children}</Title>
                                },
                                h3(props) {
                                    const { children } = props
                                    return <Title fz="xl" fw={300} order={3} mt="md" pt="sm" pb="sm">{children}</Title>
                                },
                                img(props) {
                                    const { src, alt, style, width } = props
                                    return <Image
                                        mx="auto"
                                        my="sm"
                                        src={src}
                                        alt={alt}
                                        style={style}
                                        w={width}
                                    />
                                },
                                a(props) {
                                    const { children, href } = props
                                    if (typeof children === 'string' && children.includes('CUSTOM_BUTTON')) {
                                        const content = children.replace('CUSTOM_BUTTON:', '')
                                        const onClick = () => {
                                            console.log("CTA clicked")
                                            trackEvent("Blog > CTA Clicked");
                                            redirectWithParameters('login', { signup: 'true' }, true)
                                        }
                                        return (
                                            <Group justify='center' my='md'>
                                                <Stack justify='center' my='md' gap="0">
                                                    <Button color="primary.4" size="compact-md" className="cta" onClick={onClick}>{content}</Button>
                                                    <Text size="sm" c="dimmed">.. and get 7 days free trial</Text>
                                                </Stack>
                                            </Group>
                                        )
                                    } else if (href.toLowerCase().startsWith('blog/')) {
                                        const blogId = href.toLowerCase().replace('blog/', '')
                                        const content = getBlogByLanguage(blogs[blogId], i18n.resolvedLanguage)
                                        return <Anchor href={content.url}>{children}</Anchor>
                                    } else {
                                        return <Anchor href={href}>{children}</Anchor>
                                    }
                                }
                            }}
                        />
                    </Box>
                </Paper>
            </Container>
        </>
    );
};

const BlogTemplate: React.FC = () => {
    return (
        <Layout>
            <InnerBlogTemplate />
        </Layout>
    );
};

export default BlogTemplate;